import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import { Search } from "lucide-react";

export function PeopleCheckList({ people, selected, onToggle, testid, placeholder = "Search a name…", max = "max-h-40" }) {
  const [q, setQ] = useState("");
  const filtered = (people || []).filter((p) => p.name.toLowerCase().includes(q.trim().toLowerCase()));
  return (
    <div className="space-y-1.5">
      <div className="relative">
        <Search className="absolute left-2.5 top-1/2 -translate-y-1/2 h-3.5 w-3.5 text-muted-foreground" />
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder={placeholder}
          className="h-8 pl-8 text-sm" data-testid={`${testid}-search`} />
      </div>
      <div className={`${max} overflow-auto rounded-lg border border-border p-2 space-y-1.5`} data-testid={testid}>
        {(people || []).length === 0 && <p className="text-[11px] text-muted-foreground">No people available.</p>}
        {(people || []).length > 0 && filtered.length === 0 && <p className="text-[11px] text-muted-foreground">No matches.</p>}
        {filtered.map((p) => (
          <label key={p.id} className="flex items-center gap-2 text-sm cursor-pointer">
            <Checkbox checked={selected.includes(p.id)} onCheckedChange={() => onToggle(p.id)} data-testid={`${testid}-${p.id}`} />
            <span>{p.name}</span>
          </label>
        ))}
      </div>
    </div>
  );
}
